
import { Select } from "@/shared/widgets/select";

interface PackSortProps {
  value: string;
  onChange: (value: string) => void;
}

export const PackSort = ({ value, onChange }: PackSortProps) => {
  return (
    <Select data={[
      { value: "name", label: "Nome" },
      { value: "status", label: "Status" },
      { value: "creator", label: "Creator" },
      { value: "newest", label: "Mais recente" },
      { value: "oldest", label: "Mais antigo" },
    ]} value={value} onChange={(e) => onChange(e)} />

  );
};
